import { LabelChipVariant } from '@ketch-com/deck'
import { ClassificationType } from '@ketch-com/windlass/dist/dataSentry/v1/events/events'

export const enumToLabelChipVariantMap: Record<ClassificationType, LabelChipVariant> = {
  [ClassificationType.DATA_TYPE]: LabelChipVariant.classification,
  [ClassificationType.DATA_CATEGORY]: LabelChipVariant.category,
  [ClassificationType.DATA_SENSITIVITY]: LabelChipVariant.sensitivity,
  [ClassificationType.UNSPECIFIED]: LabelChipVariant.sensitivity,
}

export const classificationTypeTitles: Record<ClassificationType, string> = {
  [ClassificationType.DATA_TYPE]: 'Data Type',
  [ClassificationType.DATA_CATEGORY]: 'Data Category',
  [ClassificationType.DATA_SENSITIVITY]: 'Data Sensitivity',
  [ClassificationType.UNSPECIFIED]: 'Unknown',
}
